module.exports = __webpack_public_path__ + "static/media/cxj_banner_two.c0e9bd76.png";